import { EmailModel } from "../schema/email.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class EmailContainer extends MongoBaseContainer{
    email: EmailModel
}
